import { render } from "./SubmitForm.vue?vue&type=template&id=6a9228a3&scoped=true&ts=true"
import script from "./SubmitForm.vue?vue&type=script&lang=ts"
export * from "./SubmitForm.vue?vue&type=script&lang=ts"

import "./SubmitForm.vue?vue&type=style&index=0&id=6a9228a3&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a9228a3"]])

export default __exports__